import { z } from "zod";
import { blogPosts, industries, products, projects, services, solutions } from "./data";

export const slugSchema = z.string().regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/);

export const contactFormSchema = z.object({
  name: z.string().min(2, "Ingresa tu nombre."),
  company: z.string().min(2, "Ingresa la empresa."),
  position: z.string().optional(),
  email: z.string().email("Ingresa un correo válido."),
  phone: z.string().min(6, "Ingresa un teléfono válido."),
  country: z.string().min(2, "Ingresa el país."),
  city: z.string().min(2, "Ingresa la ciudad."),
  interest: z.string().min(2, "Selecciona o describe tu interés."),
  message: z.string().min(10, "Cuéntanos brevemente qué necesitas."),
  projectDescription: z.string().optional(),
  quantity: z.string().optional(),
  preferredContact: z.enum(["email", "telefono", "whatsapp"]),
  privacyConsent: z.literal("on", { errorMap: () => ({ message: "Debes aceptar la política de privacidad." }) }),
  website: z.string().max(0, "Solicitud no válida.").optional()
});

const hasRequiredText = z.object({
  slug: slugSchema,
  seoTitle: z.string().min(12),
  seoDescription: z.string().min(40)
});

export function validateContent() {
  [...services, ...products, ...industries, ...solutions, ...projects, ...blogPosts].forEach((item) => {
    hasRequiredText.parse(item);
  });
  return true;
}
